import React, { useEffect, useState } from "react";
import CommonTitle from "../../components/CommonTitle";
import { IoIosAdd } from "react-icons/io";
import { useSelector } from "react-redux";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../../components/ui-elements/Notification";
import UserCard from "../../components/Users/UserCard";
import { getUsers } from "../../services/users";
import LoadingPage from "../../components/LoadingPage";
import usersIcon from "../../assets/icons/users.webp";
import ModalStructure from "../../components/ModalStructure";

const Users = () => {
  const user = useSelector((state) => state.auth.user);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const { docs } = await getUsers();
        IS_LOCAL_ENV && console.log("usuarios: ", docs);
        setUsers(docs);
        setLoading(false);
      } catch (err) {
        IS_LOCAL_ENV && console.log(err);
        Notification({
          title: "Operación fallida",
          text: "Algo salió mal...",
          type: "Error",
        });
      }
    };

    fetchUsers();
  }, []);

  const loadToParent = (newObj, prevId) => {
    let temp = [...users];
    if (!prevId) {
      temp.push(newObj);
      setUsers(temp);
    } else {
      const prevIndex = temp.findIndex((obj) => obj.id == prevId);
      if (prevIndex == -1) return;
      temp[prevIndex] = newObj;
      setUsers(temp);
    }
  };

  // const removeFromParent = (id) => {
  //   let temp = [...users];
  //   const prevIndex = temp.findIndex((obj) => obj.id == id);
  //   if (prevIndex == -1) return;
  //   temp.splice(prevIndex, 1);
  //   setUsers(temp);
  // };

  return (
    <div className="w-full h-full bg-light-green flex flex-col">
      <CommonTitle
        title={"Administración de usuarios"}
        text={"Gestiona las cuentas de usuarios"}
        img={usersIcon}
      >
        <button
          className={` w-fit bg-accent-green text-base m-1 rounded-full py-4 px-6 text-white hover:bg-dark-green transition-all duration-100 font-bold font-poppins `}
          onClick={() => setShowForm(true)}
        >
          <div className="flex flex-row items-center">
            <span className="text-nowrap">Añadir usuario</span>
            <IoIosAdd />
          </div>
        </button>
      </CommonTitle>
      {loading && <LoadingPage />}
      <div className="flex w-full justify-center bg-light-green h-fit">
        <div className="flex flex-wrap max-w-[1680px] w-full justify-center md:p-6 p-2 h-full gap-4">
          {users &&
            users.map((user, i) => {
              return (
                <UserCard
                  info={user}
                  key={i}
                  loadToParent={loadToParent}
                  // removeFromParent={removeFromParent}
                />
              );
            })}
        </div>
      </div>
      {/**Modal */}
      {showForm && (
        <ModalStructure handleCloseModal={() => setShowForm(false)}>
          <UserCard
            handleClose={() => setShowForm(false)}
            loadToParent={loadToParent}
          />
        </ModalStructure>
      )}
    </div>
  );
};

export default Users;
